import { graphql } from '../gql'

/**
 * GraphQL operations for assignments.
 *
 * Uses typed document nodes via graphql-codegen `client` preset.
 * The URQL hooks consume these typed documents directly.
 */

/** Fragment for the slim assignment card data. */
export const AssignmentCardSlimFragment = graphql(`
	fragment AssignmentCardSlimData on Assignment {
		id
		acknowledged
		active
		usesOnsiteTimes
		route {
			id
			status
			active
			startTimeLocal
			endTimeLocal
			equipment {
				id
				name
			}
			waypoints {
				id
				scheduledArrivalTime
				scheduledArrivalTimeLocal
				order {
					id
					status
				}
			}
		}
	}
`)

/** Query: Get all assignments for an operator. */
export const GetOperatorWithAssignments = graphql(`
	query GetOperatorWithAssignments($operatorId: Int!) {
		operators(where: { id: { equals: $operatorId } }) {
			id
			assignments(where: { visible: { equals: true } }) {
				id
				...AssignmentCardSlimData
			}
		}
	}
`)

/** Query: Get a single assignment with nested orders. */
export const GetAssignment = graphql(`
	query GetAssignment($assignmentId: Int!) {
		assignment(id: $assignmentId) {
			id
			acknowledged
			acknowledgedAt
			active
			usesOnsiteTimes
			crewAddendumMarkdown

			roleDetails {
				slug
				name
				sort
			}

			operator {
				id
				firstName
				lastName
			}

			route {
				id
				status
				active
				startTimeLocal
				endTimeLocal

				equipment {
					id
					name
					telematics {
						gps {
							enabled
						}
						stats {
							enabled
						}
					}
				}

				assignments {
					id
					roleDetails {
						slug
						name
						sort
					}
					operator {
						id
						firstName
						lastName
						phones {
							id
							number
						}
					}
				}

				waypoints {
					id
					status
					name
					scheduledArrivalTime
					scheduledDepartureTime
					scheduledArrivalTimeLocal
					scheduledDepartureTimeLocal
					conflictArrivalTimeLocal
					conflictDepartureTimeLocal
					actualArrivalTimeLocal
					actualDepartureTimeLocal
					address {
						street
						city
						state
						zip
						lat
						lng
					}
					order {
						id
						status
						instructions
						linesOnSite
						dateOfServiceLocal
						site {
							id
							name
							address {
								street
								city
								state
								zip
								lat
								lng
							}
						}
						customer {
							id
							name
							nickname
						}
						planned {
							id
							inventory {
								id
								quantity
								item {
									id
									name
									consumable
									displayUnit
									visibility {
										operatorAssignment
									}
								}
							}
						}
					}
				}
			}
		}
	}
`)

/** Mutation: Acknowledge an assignment. */
export const AcknowledgeAssignment = graphql(`
	mutation AcknowledgeAssignment($where: AcknowledgeAssignmentInput!) {
		acknowledgeAssignment(where: $where) {
			id
			acknowledged
			acknowledgedAt
		}
	}
`)

/** Mutation: Update route waypoint arrival/departure time. */
export const UpdateRouteWaypoint = graphql(`
	mutation UpdateRouteWaypoint($data: RouteWaypointInput!, $where: RouteWaypointWhereUniqueInput!) {
		updateRouteWaypoint(data: $data, where: $where) {
			id
			status
			actualArrivalTimeLocal
			actualDepartureTimeLocal
		}
	}
`)
